// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"497":"ccf49de3","912":"92fb673b"}[chunkId] + ".chunk.css";
};